import httpclient from '../utils/httpclient';
import {showSuccess, showError} from '../utils/msg';

import {
  TOGGLE_SIDEBAR,
  REQUEST_REPAIRE_FORM,
  RECEIVE_REPAIRE_FORM,
  REQUEST_CREATE_TICKET,
  RECEIVE_CREATE_TICKET,
  REQUEST_MY_TICKET_LIST,
  RECEIVE_MY_TICKET_LIST,
  REQUEST_TICKET_DETAIL,
  RECEIVE_TICKET_DETAIL,
  REQUEST_USER_INFO,
  RECEIVE_USER_INFO,
  REQUEST_SAVE_USER_INFO,
  RECEIVE_SAVE_USER_INFO,
  REQUEST_CHANGE_PASSWORD,
  RECEIVE_CHANGE_PASSWORD,
  REQUEST_COMMON_FAULT,
  RECEIVE_COMMON_FAULT,
  REQUEST_SERVICE_TICKET_DETAIL,
  RECEIVE_SERVICE_TICKET_DETAIL,
  REQUEST_QUERY_DEVICEINFO,
  RECEIVE_QUERY_DEVICEINFO,
  RECEIVE_QUERY_DEVICEINFO_FAIL,
  REQUEST_FETCH_SP_INFO,
  RECEIVE_FETCH_SP_INFO,
  REQUEST_FETCH_TICKET_STEPS,
  RECEIVE_FETCH_TICKET_STEPS,
} from './mutation-types';

export default {
  toggleSidebar({commit}) {
    commit(TOGGLE_SIDEBAR);
  },
  fetchReportForm({commit}) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_REPAIRE_FORM);

      httpclient.get('/repairform/default/html').then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_REPAIRE_FORM, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  publishReport({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_CREATE_TICKET);

      httpclient.post('/repairticket', payload).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_CREATE_TICKET, resp.data);
          showSuccess('已报修');
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchReportList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_MY_TICKET_LIST);

      httpclient.get('/repairticket/my/ele', {params: payload}).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_MY_TICKET_LIST, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchTicketInfo({commit}, id) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_TICKET_DETAIL);

      httpclient.get('/repairticket/mm/' + id).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_TICKET_DETAIL, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchYhlServiceTicketInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SERVICE_TICKET_DETAIL);

      httpclient.get(`/YhlCompat/fetch/${payload.spId}/i/${payload.id}/serviceticket`).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_SERVICE_TICKET_DETAIL, resp.data);
          resolve(resp);
        } else {
          commit(RECEIVE_SERVICE_TICKET_DETAIL, null);
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchUserInfo({commit}) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_USER_INFO);

      httpclient.get('/user').then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_USER_INFO, resp.data);
          resolve(resp.data);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  saveUserInfo({commit}, payload) {
    commit(REQUEST_SAVE_USER_INFO);

    httpclient.post('/user', payload).then(resp => {
      if (resp.biz_code === 0) {
        commit(RECEIVE_SAVE_USER_INFO, payload);
        showSuccess('保存成功');
      } else {
        showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
      }
    });
  },
  updatePassword({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_CHANGE_PASSWORD);

      httpclient.post('/user/updatepwd', payload).then(resp => {
        commit(RECEIVE_CHANGE_PASSWORD);
        if (resp.biz_code === 0) {
          showSuccess('密码修改成功');
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchBindingInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/yhlcompat/fetch/${payload.spId}/binding`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchCommonFault({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_COMMON_FAULT);

      httpclient.get(`/YhlCompat/fetch/${payload.spId}/commonfault`).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_COMMON_FAULT, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchSpInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FETCH_SP_INFO);

      httpclient.get(`/serviceprovider/id/${payload.spId}`).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_FETCH_SP_INFO, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchDeviceInfoByText({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_QUERY_DEVICEINFO);

      httpclient.get(`/yhlcompat/fetch/${payload.spId}/s/${payload.text}`).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_QUERY_DEVICEINFO, resp.data);
          resolve(resp);
        } else {
          commit(RECEIVE_QUERY_DEVICEINFO_FAIL);
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchDeviceInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_QUERY_DEVICEINFO);

      httpclient.get(`/yhlcompat/fetch/${payload.spId}/i/${payload.deviceId}`).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_QUERY_DEVICEINFO, resp.data);
          resolve(resp);
        } else {
          commit(RECEIVE_QUERY_DEVICEINFO_FAIL);
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  publishSimpleReport({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_CREATE_TICKET);

      httpclient.post('/repairticket/lite/anonymous', payload).then(resp => {
        commit(RECEIVE_CREATE_TICKET, resp.data);
        if (resp.biz_code === 0) {
          showSuccess('已报修');
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  fetchTicketSteps({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FETCH_TICKET_STEPS);

      httpclient.get(`/repairticket/mm/${payload.ticketId}/steps`).then(resp => {
        commit(RECEIVE_FETCH_TICKET_STEPS, resp.data);
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  getRatingInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/point/${payload.ticketId}/info`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  getMoreRatingTags({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/tags/${payload.spId}/more`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  rateTicket({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/rate/point`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess('已评价');
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  getTicketRateInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/point/${payload.ticketId}`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  checkTicketCanRate({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/point/check/${payload.ticketId}`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
  getTicketGeoInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/RepairTicket/mm/${payload.ticketId}/geo`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || '处理您的请求时发生错误, 请重试');
          reject(resp);
        }
      });
    });
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js